import $ from 'jquery';

export default function footerSection() {
	const $html = $('html');
	const $scroller = $('html, body');
	const $wholeBody = $('html, body, main#content');

	const $footer = $('#footer');
	let footerHeight = $footer.outerHeight();

}



// WEBPACK FOOTER //
// ./source/scripts/sections/footer.js